module.exports = __webpack_public_path__ + "static/media/civilWar.42eb5572.jpeg";